import React from "react";
import ShareYourIdeaRedesign from "../redesign/ShareYourIdeaRedesign";

const ShareYourIdea = () => {
  return <ShareYourIdeaRedesign />;
};

export default ShareYourIdea;
